import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { ref: "game" }

import { ref, onMounted } from 'vue';
import Phaser from 'phaser';
import Scenes from './scenes/scenes';
import WarpPipelinePlugin from 'phaser3-rex-plugins/plugins/warppipeline-plugin.js';
import ClockPlugin from 'phaser3-rex-plugins/plugins/clock-plugin.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'phaser',
  setup(__props) {

const gameContainerEl = ref<HTMLDivElement>();
onMounted(() => {
    new Phaser.Game({
        type: Phaser.WEBGL,
        parent: gameContainerEl.value,
        backgroundColor: '#000000',
        scene: Scenes,
        transparent: true,
        // physics: {
        //     default: 'arcade',
        //     arcade: {
        //         debug: true
        //         // gravity: {
        //         //     y: 200
        //         // }
        //     }
        // },
        // antialias: false,
        // antialiasGL: false,
        scale: {
            width: '100%',
            height: '100%',
            mode: Phaser.Scale.RESIZE,
            autoCenter: Phaser.Scale.CENTER_BOTH
        },
        // pipeline: [WarpPostFx],
        plugins: {
            global: [
                // {
                //     key: 'rexHorrifiPipeline',
                //     plugin: HorrifiPipelinePlugin,
                //     start: true
                // },
                {
                    key: 'rexWarpPipeline',
                    plugin: WarpPipelinePlugin,
                    start: true
                },
                {
                    key: 'rexClock',
                    plugin: ClockPlugin,
                    start: true
                }
            ]
        }
        // audio: {
        //     disableWebAudio: true
        // }
    })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, null, 512))
}
}

})